// import "antd/dist/antd.css";
import React, { useState, useEffect } from "react";
import { exportTableToPDF } from "./utils/exportPDF";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// import BlinkingDot from "./Blinking";
import { DatePicker, Space } from "antd";
// import {read, utils, writeFile} from 'xlsx';
const { RangePicker } = DatePicker;

const RequisitionAdmin = () => {
  const [dates, setDates] = useState([]);
  const [requisitionList, setRequisitionList] = useState([]);
  const [kitchenName, setFilterDate] = useState("");

  const [kitchens, setKitchens] = useState([]);
  const [itemDetails, setItemDetails] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(requisitionList.length / itemsPerPage);
  const paginatedList = requisitionList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    fetchKitchens();
    fetchRequisitionList();
  }, []);

  const fetchKitchens = async (date = "") => {
    try {
      const url = date
        ? `https://ims-backend.indevconsultancy.in/api/kitchens/?kitchens_name=${date}`
        : `https://ims-backend.indevconsultancy.in/api/kitchens/`;
      const response = await axios.get(url);
      setKitchens(response.data);
    } catch (error) {
      console.error("Error fetching kitchens:", error);
    }
  };

  const fetchRequisitionList = async (date = "") => {
    try {
      const url = date
        ? `https://ims-backend.indevconsultancy.in/api/kitchens/?kitchens_name=${date}`
        : `https://ims-backend.indevconsultancy.in/api/kitchens/`;

      const response = await axios.get(url);
      if (response.data && Array.isArray(response.data)) {
        setRequisitionList(response.data);
      } else {
        setRequisitionList([]);
      }
    } catch (error) {
      console.error("Error fetching requisitions:", error);
      setRequisitionList([]);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (kitchenName) {
      fetchRequisitionList(kitchenName);
    } else {
      fetchRequisitionList();
    }
  };

  //   const exportToCSV = () => {
  //   if (!requisitionList.length) return;

  //   const headers = ['Requisition ID', 'Date', 'Kitchen Name', 'Items', 'Purchase No.', 'Status'];

  //   const rows = requisitionList.map((item, index) => {
  //     // Example: join actual data from item if available
  //     const items = item.items ? item.items.join(', ') : 'item1, item2, item3';
  //     const purchaseNumbers = item.purchase_numbers ? item.purchase_numbers.join(', ') : '123, 567, 976';

  //     return [
  //       index + 1,
  //       new Date().toLocaleDateString(),
  //       item.kitchen_name,
  //       items,
  //       purchaseNumbers,
  //       'Received'
  //     ];
  //   });

  //   let csvContent = 'data:text/csv;charset=utf-8,';
  //   csvContent += headers.join(',') + '\n';
  //   rows.forEach(row => {
  //     csvContent += row.map(val => `"${val}"`).join(',') + '\n'; // quote fields for safety
  //   });

  //   const encodedUri = encodeURI(csvContent);
  //   const link = document.createElement('a');
  //   link.setAttribute('href', encodedUri);
  //   link.setAttribute('download', 'requisition_list.csv');
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const exportToCSV = () => {
    if (!requisitionList.length) return;

    const headers = [
      "Requisition ID",
      "Date",
      "Kitchen Name",
      "Items",
      "Purchase No.",
      "Status",
    ];

    const rows = requisitionList.map((item, index) => {
      // Safely access items and purchase numbers (assuming they are arrays)
      const items = Array.isArray(item.items) ? item.items.join(", ") : "N/A";
      const purchaseNumbers = Array.isArray(item.purchase_numbers)
        ? item.purchase_numbers.join(", ")
        : "N/A";

      return [
        index + 1,
        new Date().toLocaleDateString(),
        item.kitchen_name || "N/A",
        items,
        purchaseNumbers,
        item.status || "N/A",
      ];
    });

    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += headers.join(",") + "\n";
    rows.forEach((row) => {
      // Add double quotes around each cell to safely handle commas
      csvContent += row.map((cell) => `"${cell}"`).join(",") + "\n";
    });

    // Trigger download
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "requisition_list.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportToPDF = () => {
    if (!requisitionList.length) return alert("No data to export.");
    const headers = ["Requisition ID", "Date", "Kitchen Name", "Items", "Purchase No.", "Status"];
    const rows = requisitionList.map((item, index) => [
      index + 1,
      new Date().toLocaleDateString(),
      item.kitchen_name || "N/A",
      Array.isArray(item.items) ? item.items.join(", ") : "N/A",
      Array.isArray(item.purchase_numbers) ? item.purchase_numbers.join(", ") : "N/A",
      item.status || "N/A",
    ]);
    exportTableToPDF({ title: "Admin - Requisition List", headers, rows, filename: "requisition_list.pdf", filterInfo: `Total: ${rows.length}` });
  };

  const navigate = useNavigate();
  return (
    <div className="container-fluid px-2">
      <div className="row">
        <div className="col mt-2">
          <span className="fs-1">Requisition List</span>
        </div>
        <div className="col">
          <nav className="py-2" aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-end">
              <li className="breadcrumb-item active">Requisition List</li>
              <li className="breadcrumb-item">
                <Link to="/mobilehome">Home</Link>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="card">
        <div className="card-header border-info">
          <form onSubmit={handleSearch}>
            <div className="row g-3">
              <div className="col-lg">
                <select
                  name="datefilter"
                  className="form-select"
                  id="datefilter"
                >
                  <option value="Last 7 days" selected="">
                    Select Kitchen
                  </option>
                  <option value="Last 7 days" selected="">
                    Sonu Kitchen
                  </option>
                  <option value="Last 7 days" selected="">
                    Deepal-KICHEN
                  </option>
                </select>
              </div>

              {/* <div className="col-lg">
                <input type="date" className="form-select" />
              </div>

              <div className="col-lg">
                <input type="date" className="form-select" />
              </div> */}

              <div className="col-lg">
                <RangePicker
                  style={{
                    width: "100%",
                    height: "38px",
                    borderRadius: "0.375rem",
                    border: "1px solid #ced4da",
                    padding: "0.375rem 0.75rem",
                  }}
                />
              </div>

              <div className="col-lg-2">
                <button type="submit" className="btn btn-primary w-100">
                  Search
                </button>
              </div>
              <div className="col-lg-1">
                <button
                  type="button"
                  onClick={() => {
                    setFilterDate("");
                    fetchRequisitionList(); // fetch all
                  }}
                  className="btn btn-outline-dark w-100"
                >
                  Reset
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h6 className="fw-bold mb-0">
              Total Item(s): <span>{requisitionList.length}</span>
            </h6>
            <div>
              <button className="btn btn-primary btn-sm me-1" onClick={exportToCSV}>
                <i className="fas fa-file-csv me-1"></i> Export CSV
              </button>
              <button className="btn btn-danger btn-sm" onClick={exportToPDF}>
                <i className="fas fa-file-pdf me-1"></i> Export PDF
              </button>
            </div>
          </div>

          <div className="table-responsive scrollbar mt-2">
            <table className="table text-center table-bordered table-striped fs--1 mb-0">
              <thead className="bg-primary text-white">
                <tr>
                  <th>Requisition ID</th>
                  <th>Date</th>
                  <th>Kitchen Name</th>
                  <th>Items</th>
                  <th>Purchase No.</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedList.length === 0 ? (
                  <tr>
                    <td colSpan="3">No data</td>
                  </tr>
                ) : (
                  paginatedList.map((item, index) => {
                    return (
                      <tr key={item.kitchen_id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{new Date().toLocaleDateString()}</td>
                        <td>
                          {item.kitchen_name} <a href="#">(K_ID)</a>
                        </td>
                        <td>
                          <a href="#">item1, item2, item3</a>
                        </td>
                        <td>
                          <a href="#">123, 567, 976</a>
                        </td>
                        <td>
                          <button className="bg-success rounded border-0 text-white">
                            Recieved
                          </button>
                        </td>
                        <td>
                          <button
                            className="btn btn-primary"
                            onClick={() => navigate(`/POList`)} // or any route you need
                          >
                            <i className="fas fa-eye"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequisitionAdmin;
